import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";
import { TEventTab } from "store/eventList/EventList.types";
import {
  ArrowIcon,
  DropdownItem,
  DropdownMenu,
  EventsListHeader,
} from "./NewEvents.styles";
import { useAppSelector } from "store/hooks";
import { isUserMySelf, selectUserType } from "store/user/user.selectors";

interface EventsFilterBarProps {
  selectedTab: TEventTab;
  isDropdownOpen: boolean;
  toggleDropdown: () => void;
  handleTabChange: (type: TEventTab) => void;
}

const EventsFilterBar: React.FC<EventsFilterBarProps> = ({
  selectedTab,
  isDropdownOpen,
  toggleDropdown,
  handleTabChange,
}) => {
  const tabLabels = {
    [TEventTab.PAST]: "Past Events",
    [TEventTab.UPCOMING]: "Upcoming Events",
    [TEventTab.CANCELLED]: "Canceled Events",
    [TEventTab.TENTATIVE]: "Draft Events",
  };
  
  const isMySelf = useAppSelector(isUserMySelf);

  const tabLabel = tabLabels[selectedTab];
  return (
    <>
      <EventsListHeader>
        {tabLabel}
        <ArrowIcon onClick={toggleDropdown} isOpen={isDropdownOpen}>
          <ExpandMoreIcon />
        </ArrowIcon>
      </EventsListHeader>
      {isDropdownOpen && (
        <DropdownMenu>
          <DropdownItem onClick={() => handleTabChange(TEventTab.PAST)}>
            {tabLabels[TEventTab.PAST]}
          </DropdownItem>
          <DropdownItem onClick={() => handleTabChange(TEventTab.UPCOMING)}>
            {tabLabels[TEventTab.UPCOMING]}
          </DropdownItem>
          <DropdownItem onClick={() => handleTabChange(TEventTab.CANCELLED)}>
            {tabLabels[TEventTab.CANCELLED]}
          </DropdownItem>
          {!isMySelf && (
            <DropdownItem onClick={() => handleTabChange(TEventTab.TENTATIVE)}>
              {tabLabels[TEventTab.TENTATIVE]}
            </DropdownItem>
          )}
        </DropdownMenu>
      )}
    </>
  );
};

export default EventsFilterBar;
